// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"l1-z"};